export default ({...props}) => {
  const {themeGrey, space, size} = props.theme
  return `
    display: flex;
    align-items: center;
    padding-bottom: ${space(1)}px;
    margin-bottom: ${space(1)}px;
    &[ap_type="book_date_modal"]{
        & > p.MuiTypography-root{
        text-transform:lowercase;
        &:first-letter{
        text-transform:uppercase;
        }  
        }
    }
    & > p.MuiTypography-root {
        margin-bottom: 0;
    }

    @media screen and (max-width:501px) {
        border-bottom: 1px solid ${themeGrey.border_grey};
        & > p.MuiTypography-root {
        padding-left:${size(1)}px;
        &[ahd_type="h6"]{
            text-align: left;
            line-height: initial;
        }
        }
    }

    @media screen and (max-width:400px) {
        & > p.MuiTypography-root {
        font-size: ${size(2.625)}px;
        }
    }
        `
}
